import { createTheme } from "@mui/material";

// --- 2. MUI CUSTOM THEME DEFINITION ---
const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#3F51B5', // Indigo (Main Accent)
    },
    secondary: {
      main: '#059669', // Emerald Green (Success/Completion)
    },
    action: {
        disabledBackground: '#e0e0e0',
    },
    info: {
        main: '#1976D2',
    }
  },
  typography: {
    fontFamily: ['"Roboto"', 'sans-serif'].join(','),
    h4: {
      fontWeight: 600,
      fontSize: '1.8rem',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
          padding: '5px 0px',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 8px 20px rgba(0, 0, 0, 0.08)',
        },
      },
    },
  },
});

export default theme;